var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirtable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    fill: "none",
    viewBox: "0 0 29 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB400",
    d: "M12.6399 0.2988L2.08646 4.66568C1.49958 4.90856 1.50566 5.74216 2.09622 5.97624L12.6938 10.1788C13.625 10.5481 14.662 10.5481 15.593 10.1788L26.1908 5.97624C26.7812 5.74216 26.7874 4.90856 26.2004 4.66568L15.6471 0.2988C14.6842 -0.0996 13.6026 -0.0996 12.6399 0.2988Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#18BFFF",
    d: "M15.0836 12.4737V22.9722C15.0836 23.4716 15.5871 23.8135 16.0513 23.6295L27.8603 19.0458C28.1299 18.939 28.3067 18.6785 28.3067 18.3886V7.88999C28.3067 7.39063 27.8031 7.04871 27.339 7.23271L15.53 11.8164C15.2606 11.9233 15.0836 12.1838 15.0836 12.4737Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F82B60",
    d: "M12.3262 13.0154L8.82156 14.7076L8.46572 14.8796L1.06764 18.4244C0.598682 18.6506 0.00012207 18.3089 0.00012207 17.7879V7.93413C0.00012207 7.74565 0.0967621 7.58293 0.226362 7.46037C0.280442 7.40613 0.341722 7.36149 0.405402 7.32613C0.582202 7.22005 0.834362 7.19173 1.04876 7.27653L12.2673 11.7215C12.8376 11.9477 12.8824 12.7468 12.3262 13.0154Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.3262 13.0154L8.82152 14.7076L0.226318 7.46037C0.280398 7.40613 0.341678 7.36149 0.405358 7.32613C0.582158 7.22005 0.834318 7.19173 1.04872 7.27653L12.2673 11.7215C12.8375 11.9477 12.8823 12.7468 12.3262 13.0154Z",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/airtable.987b01f4.svg";
export { ForwardRef as ReactComponent };